import React from 'react';
import Avatar from 'sharedComponents/Avatar';
import { CheckIcon } from 'sharedComponents/Icons';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

const ClientListItemEmpty = ({ classes }) => {
  return (
    <ListItem disableGutters className={classes.link}>
      <ListItemAvatar data-testid="group-clients-select">
        <Avatar className={classes.avatar}>
          <CheckIcon className={classes.icon} />
        </Avatar>
      </ListItemAvatar>
    </ListItem>
  );
};

ClientListItemEmpty.propTypes = {};

ClientListItemEmpty.defaultProps = {};

export default React.memo(ClientListItemEmpty);
